import React from "react"
import Svg from "../../shared/_svgs/svg"

export default function IconLinkContainerItem({ altText, image, link, linkTarget, linkTitle, text, svgIcon }) {
  return (
    <a data-epi-property="Link" lang="da" className="icon-link-item" title={linkTitle} target={linkTarget} href={link}>
      <div className="icon-link-image-container">
        {svgIcon && svgIcon != "None" ? <Svg iconName={svgIcon}></Svg> : <img data-epi-property="Image" alt={altText} src={image}></img>}
      </div>
      <div className="card-text-container">
        <p data-epi-property="Text" className="card-text">
          {text}
        </p>
        <div className="link-text-container">
          <Svg iconName="arrowright-slim"></Svg>
        </div>
      </div>
    </a>
  )
}
